export { default } from './FloatingNotification.js';
